// Shared constants for the public AEO leaderboard. Imported by the server
// function that builds the list AND by PublicAuditResults so the
// "you're eligible" callout uses the same threshold.

export const LEADERBOARD_MIN_AEO_SCORE = 70;
export const LEADERBOARD_MIN_ENTRIES_TO_SHOW = 8;
export const LEADERBOARD_TOP_N = 20;

export interface LeaderboardEntry {
  rank: number;
  slug: string;
  hostname: string;
  aeoScore: number;
  storeScore: number | null;
  auditedAt: string;
}

export interface LeaderboardData {
  entries: LeaderboardEntry[];
  qualifying: number;
}